var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"check_item"},[_c('h2',[_vm._v("選択中の製品")]),_c('ul',{staticClass:"meta_container"},_vm._l((_vm.metaList),function(meta){return _c('li',{key:meta,staticClass:"meta_block"},[_vm._v(_vm._s(meta))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }